// MMP1 - FH Salzburg - MultiMediaTechnology
// Tobias Franek <tfranek.mmt-b2018@fh-salzburg.ac.at>

import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { observable } from 'mobx';
import Request from '../../../../api/Request';
import Comment from '../../../Comment/Comment';
import CircleLoader from '../../../Util/CircleLoader/CircleLoader';
import Button from '../../../Util/Button/Button';
import { Redirect } from 'react-router';
import CommentBox from '../../../Comment/CommentBox/CommentBox';

@inject('userStore', 'componentStore', 'messageStore')
@observer class CommentSection extends Component<any, any> {

	@observable comments: any[] = [];

	steps: number = 5;
	currentPosition: number = 0;

	alreadyCentered: boolean = false;

	@observable empty: boolean = false;
	@observable loading: boolean = false;

	@observable matchId?: number;

	currentlyFetching: boolean = false;

	constructor(props: any) {
		super(props);

		this.match = this.match.bind(this);
		this.fetch = this.fetch.bind(this);
		this.fetchNew = this.fetchNew.bind(this);
		this.more = this.more.bind(this);
		this.createComment = this.createComment.bind(this);
	}

	componentDidMount() {
		this.fetch();
	}

	componentDidUpdate() {
		if ((this.comments.length > 0 || this.empty) && !this.alreadyCentered) {
			this.props.center();
			this.alreadyCentered = true;
		}

		if (this.props.receivedComment && !this.props.receivedComment.handled) {
			if (this.props.receivedComment.action && this.props.receivedComment.action === 'refetch') {
				this.fetchNew();
			} else {
				if (this.comments.length === 0) {
					this.comments = [
						this.props.receivedComment
					]
				} else if (this.comments[0].id !== this.props.receivedComment) {
					this.comments = [
						this.props.receivedComment,
						...this.comments
					]
				}
			}
			this.props.receivedComment.handled = true;
		}
	}

	fetch() {
		if(!this.empty)  {
			Request.get('/questions/' + this.props.question.id + '/comments?questionOption=' + this.props.question.question_options[this.props.order].id + '&orderBy[createdAt]=DESC&offset=' + this.currentPosition + '&limit=' + this.steps, {}).then((response) => {
				if(!response.status) {
					if (response.length === this.steps) {
						this.comments = [...this.comments, ...response];
					} else {
						if(response.length < this.steps) {
							this.comments = [...this.comments, ...response];
						}
						this.empty = true;
					}
					this.loading = false;
				}
			})
		}
	}

	fetchNew() {
		if(!this.currentlyFetching) {
			this.currentlyFetching = true;	 
			Request.get('/questions/' + this.props.question.id + '/comments?questionOption=' + this.props.question.question_options[this.props.order].id + '&orderBy[createdAt]=DESC&limit=' + this.steps, {}).then((response) => {
				if(!response.status) {
					this.props.componentStore.justRemovedComments = undefined;
					if (response.length > 0) {
						this.comments = response;
					} else {
						this.comments = response;
						this.empty = true;
					}
					this.props.center();
					this.currentlyFetching = false;
				}
			})
		}
	}

	more() {
		this.loading = true;
		this.currentPosition += this.steps;
		this.fetch();
	}

	match(e: any, challengedId: number) {
		Request.post('/questions/' + this.props.question.id + '/matches', {
			challengedCommentId: challengedId
		}, {}).then((response) => {
			if(!response.status) {
				this.matchId = response.id;
			}
		})
	}

	async createComment(comment: string): Promise<boolean> {
		if(comment !== '') {
			const response =  await Request.post('/questions/' + this.props.question.id + '/comments', {
				content: comment,
				questionOption: this.props.question.question_options[this.props.order].id
			}, {});

			if(!response.status) {
				this.currentPosition += 1;
				return true;
			} else {
				return false;
			}
		} else {
			this.props.messageStore.setMessage('error', 'the comment field cannot be empty');
		}
		return false;
	}

	render() {
		if (this.matchId) {
			return <Redirect to={'/match/' + this.matchId} />
		}
		if(this.props.componentStore.justRemovedComments && this.props.componentStore.justRemovedComments === this.props.question.question_options[this.props.order].id && this.comments.length > 0) {
			this.fetchNew();
		}
		return (
			<div className={"comment-section comment-section-" + this.props.order}>
				{(this.props.userStore.user && this.props.componentStore.chosenOptionId && this.props.question.question_options[this.props.order].id === this.props.componentStore.chosenOptionId) && this.props.order === 1 ? 
					<CommentBox 
						onSubmit={this.createComment} 
					/>
				:
					null
				}
				{this.comments.length > 0 ? (
					<div className="comments-wrapper">
						{!this.empty && this.props.order === 0 ? <Button text='more' loading={this.loading} onClick={this.more}/> : null}
						{this.props.order === 0 ? 
							(<div>
								{this.comments.slice().reverse().map((comment, index) => {
									return (
											<Comment 
												match={!this.props.userStore.user || !this.props.componentStore.chosenOptionId || this.props.question.question_options[this.props.order].id === this.props.componentStore.chosenOptionId ? null : this.match} 
												comment={comment} 
												key={index}/>
									)}
								)}
							</div>)
						:
							(<div>
								{this.comments.map((comment, index) => {
									return (
											<Comment 
												match={!this.props.userStore.user || !this.props.componentStore.chosenOptionId || this.props.question.question_options[this.props.order].id === this.props.componentStore.chosenOptionId ? null : this.match} 
												comment={comment} 
												key={index}/>
									)})
								}
							</div>)
						}
						
						{!this.empty && this.props.order === 1 ? <Button text='more' loading={this.loading} onClick={this.more}/> : null}
						
					</div>
					)
					:
					<div className="comments-wrapper">{this.empty ? <p className="no-comments">No comments yet.</p> : <CircleLoader size={30} /> }</div>
				}
				{(this.props.userStore.user && this.props.componentStore.chosenOptionId && this.props.question.question_options[this.props.order].id === this.props.componentStore.chosenOptionId) && this.props.order === 0 ? 
					<CommentBox 
						onSubmit={this.createComment} 
					/>
				:
					null
				}
			</div>
		)
	}
}

export default CommentSection;

